import { Avatar, Box, Button, Divider, Fab, Typography, useTheme } from '@mui/material'
import React from 'react'
import stringAvatar from '../../lib/stringAvatar'
import { format, parseISO } from 'date-fns'
import Assets from '../Common/Assets'
import { Link, useNavigate } from 'react-router-dom'

import FilterListIcon from '@mui/icons-material/FilterList';
import AddIcon from '@mui/icons-material/Add';
import { useCommonStyles } from '../../utils'
const Notifications = ({ notificationData, setIsOpenNotification }) => {
    // ============ Hooks ============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const navigate = useNavigate()
    // ============ Handler ============
    const formatDate = (dateString) => {
        const date = parseISO(dateString);
        return format(date, "EEEE 'at' h:mm a");
    };
    return (
        <Box>
            <Box padding={"25px"} display={"flex"} flexDirection={"column"} gap={2} height={'75vh'} overflow={"auto"}>
                {notificationData?.response?.map((ele) => {
                    return (
                        <>
                            <Box display={"flex"} justifyContent={"space-between"} alignItems={"start"} gap={5}>
                                <Box display={"flex"} gap={2} alignItems={"start"} >
                                    {/* {ele?.profilePicture ? (
                                    <Avatar src={ele?.profilePicture} style={{ height: "50px", width: "50px" }} />
                                ) : (
                                    ele?.name ? (
                                        <Avatar {...stringAvatar(ele?.name)} style={{ height: "40px", width: "40px" }} />
                                    ) : (
                                        <Avatar style={{ height: "40px", width: "40px" }} />
                                    )
                                )} */}
                                    <Fab sx={{ boxShadow: "none", backgroundColor: "#F5F9FB", height: "48px", width: "48px" }}>
                                        <Assets absolutePath={true} src={`/assets/img/Notification.svg`} />
                                    </Fab>
                                    <Box>
                                        <Typography color={"#1A1F36"} fontSize={'14px'} fontFamily={"Satoshi-Medium"}>{ele?.subTitle}</Typography>
                                        <Box maxHeight={"50px"} overflow={"auto"}
                                            sx={{
                                                textAlign: "left",
                                                paddingLeft: "10px",
                                                marginTop: "10px",
                                                direction: "rtl",
                                                "& > *": { direction: "ltr" }
                                            }}
                                        >
                                            <Typography color={"#1A1F36"} fontSize={'14px'} fontFamily={"Satoshi-Medium"}>
                                                {ele?.description}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                                <Typography color={"#A5ACB8"} fontSize={'12px'} whiteSpace={'nowrap'} fontFamily={"Satoshi-Light"}>
                                    {ele?.dateAndTime ? formatDate(ele?.dateAndTime) : ""}
                                </Typography>
                            </Box>
                            <Divider />
                        </>
                    )
                })}
            </Box>
            <Box paddingX={"25px"} textAlign={"end"}>
                <Button className={classes.saveButton} onClick={() => { setIsOpenNotification(false); navigate('/notification') }}>View All</Button>

            </Box>
        </Box>
    )
}

export default Notifications